<template>
  <modal id="manual-reward-modal"
         size="large"
         v-model="showModal"
         :title="$fieldTitle(buttonFirstTitle, 'send_reward', true)"
         @submit="submitData"
         :scrollable="false"
         :loading="loading"
         :preloader="preloader">
    <form
        ref="form"
        @submit.prevent="submitData"
    >
      <app-form-group
          :label="$t('reward')"
          type="decimal"
          v-model="formData.reward"
          :placeholder="$placeholder('reward')"
          :required="true"
          :error-message="$errorMessage(errors, 'reward')"
      />
    </form>
  </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {
  formatDateTimeForServer,
  formatDateForServer,
  timezoneDate
} from "../../../../../common/Helper/Support/DateTimeHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {AUTO_EMPLOYEE_ID} from "../../../../Config/ApiUrl";

export default {
  name: "ManualRewardModal",
  mixins: [ModalMixin, FormHelperMixins],
  props: {
    tableId: {},
    employee: {},
    specificId: {}
  },
  data() {
    return {
      formData: {},
      maxDate: timezoneDate()
    }
  },
  mounted() {
    this.$nextTick(()=>{
      if (window.innerHeight < 700){
        document.getElementsByClassName('modal-body')[0].style.height = '560px'
      }
    })
  },
  methods: {
    submitData() {
      this.loading = true;
      const formData = {...this.formData};
      formData.reward = this.formData.reward;

      this.submitFromFixin(
          'post',
          `${this.apiUrl.EMPLOYEES}/manual-reward`,
          formData
      );
    },
    afterSuccess({data}) {
      this.loading = false;
      $('#manual-reward-modal').modal('hide');
      this.$toastr.s('', data.message);
      if (this.tableId) {
        this.$hub.$emit(`reload-${this.tableId}`);
      } else {
        this.$emit('reload')
      }
    },
  },
  created() {
    if (!this.employee && !this.canSendManualReward && !this.specificId) {
      this.formData.employee_id = window.user.id
    }

    if (this.specificId) {
      this.formData.employee_id = this.specificId
      this.formData.reward = 0
    }
  },
  computed: {
    canSendManualReward() {
      if (this.specificId && this.$can('send_manual_reward')) {
        return false;
      }
      if (this.employee && this.$can('send_manual_reward')) {
        this.formData.employee_id = this.employee.id
        return false;
      }
      return this.$can('send_manual_reward');
    },
    user_id() {
      return window.user.id;
    },
    buttonFirstTitle() {
      return this.$can('send_manual_reward') ? '' : 'request';
    }
  }
}
</script>